module.exports = __webpack_public_path__ + "static/63invgde-f38d65a60965c4072fc1d6f6b314dfce.gif";